import { customerCardStyles as styles } from "@insite/content-library/Components/CustomerCard";
import getColor from "@insite/mobius/utilities/getColor";
import { colorStrings, mediaQueriesBP } from "@solveindustrial/Utilities/variables";
import { css } from "styled-components";

styles.selectButton = { variant: "secondary" };

styles.address = {
    ...styles.address,
    customerNameText: { as: "p", variant: "p" },
    attentionText: { as: "p", variant: "p" },
    companyNameText: { as: "p", variant: "p" },
    address1Text: { as: "p", variant: "p" },
    address2Text: { as: "p", variant: "p" },
    address3Text: { as: "p", variant: "p" },
    address4Text: { as: "p", variant: "p" },
    cityStatePostalCodeText: { as: "p", variant: "p" },
    countryText: { as: "p", variant: "p" },
    phoneText: { as: "p", variant: "p" },
    emailText: { as: "p", variant: "p" },
    faxText: { as: "p", variant: "p" },
};
